import React from 'react';
import { Box } from '@mui/material';
import { DossierStatus } from '../../../liste';

interface StatusWithChipProps {
    statut: string;
}

export const StatusWithChip: React.FunctionComponent<StatusWithChipProps> = function ({ statut }) {
    return (
        <Box sx={{ display: 'flex', gap: '0 8px', alignItems: 'center' }}>
            <DossierStatus label={statut} />
        </Box>
    );
};
